// Version : 1.0.0
// Author : AGALYA

import { takeLatest, put, all, call } from 'redux-saga/effects';
import PassbookChequeDetailsActionType from './passbook-cheque-details.types';
import {
	updatePassbookChequeSuccess,
	updatePassbookChequeFailure,
	updatePassbookChequeResponseChanged,
} from './passbook-cheque-details.action';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import { passbookChequeUpdateDetails } from './passbook-cheque-details.service';

/** ***************** PassbookCheque Update Start ************************/
export function* updatePassbookChequeIdDetails({ payload }: any) {
	try {
		const key = 'updatePassbookChequeID';
		const { companyID, databaseName, memberID, memberPassbookChequeImg, userID } = payload;

		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			MemberID: memberID,
			MemberPassbookChequeImg: memberPassbookChequeImg,
			OfficerID: userID,
			Secratekey: key,
		};

		const passbookChequeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(passbookChequeUpdateDetails, passbookChequeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updatePassbookChequeFailure(responseData.data));
		} else {
			yield put(updatePassbookChequeSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updatePassbookChequeFailure(error));
	}
}

export function* updatePassbookChequeDetailsResponseClear() {
	yield put(updatePassbookChequeResponseChanged());
}

export function* onPassbookChequeDetailsUpdateStart() {
	yield takeLatest(
		PassbookChequeDetailsActionType.UPDATE_PASSBOOK_CHEQUE_START,
		updatePassbookChequeIdDetails,
	);
}

export function* onPassbookChequeDetailsUpdateResponseRest() {
	yield takeLatest(
		PassbookChequeDetailsActionType.UPDATE_PASSBOOK_CHEQUE_RESPONSE_REST_START,
		updatePassbookChequeDetailsResponseClear,
	);
}
/** ***************** PassbookCheque Update End ************************/

export function* passbookChequeDetailsSaga() {
	yield all([
		call(onPassbookChequeDetailsUpdateStart),
		call(onPassbookChequeDetailsUpdateResponseRest),
	]);
}
